import HttpClient from '@/common/lib/http-client'
import { IPost, Post } from '@/common/models/data/dashboard/posts/post'
import { IPaginatedResponse, PaginatedResponse } from '@/common/models/data/common/pagination/paginated-response'

import { posts as Api } from '@/app/api'
import NotFoundError from '@/common/errors/not-found-error'

class PostsRepository {
    private static errorTag = 'PostsRepository'

    async byAuthor (authorId: number, page = 1): Promise<PaginatedResponse<Post>> {
        const response = await HttpClient.getJson<IPaginatedResponse<IPost>>(Api.byAuthor(authorId, page))

        if (response.meta.current_page > response.meta.last_page) {
            throw new NotFoundError(PostsRepository.errorTag)
        }

        return PaginatedResponse.fromInterface(response, (dto): Post => {
            return new Post(dto)
        })
    }

    async byDate (date: Date, page = 1): Promise<PaginatedResponse<Post>> {
        const response = await HttpClient.getJson<IPaginatedResponse<IPost>>(Api.byDate(date, page))

        if (response.meta.current_page > response.meta.last_page) {
            throw new NotFoundError(PostsRepository.errorTag)
        }

        return PaginatedResponse.fromInterface(response, (dto): Post => {
            return new Post(dto)
        })
    }

    async byTag (tagSlug: string, page = 1): Promise<PaginatedResponse<Post>> {
        const response = await HttpClient.getJson<IPaginatedResponse<IPost>>(Api.byTag(tagSlug, page))

        if (response.meta.current_page > response.meta.last_page) {
            throw new NotFoundError(PostsRepository.errorTag)
        }

        return PaginatedResponse.fromInterface(response, (dto): Post => {
            return new Post(dto)
        })
    }

    async dates (): Promise<Array<string>> {
        return HttpClient.getJson<Array<string>>(Api.dates)
    }

    async index (page = 1): Promise<PaginatedResponse<Post>> {
        const response = await HttpClient.getJson<IPaginatedResponse<IPost>>(Api.index(page))

        if (response.meta.current_page > response.meta.last_page) {
            throw new NotFoundError(PostsRepository.errorTag)
        }

        return PaginatedResponse.fromInterface(response, (dto): Post => {
            return new Post(dto)
        })
    }

    async search (query: string): Promise<Array<Post>> {
        if (query === '') {
            return []
        }

        const response = await HttpClient.getJson<Array<IPost>>(Api.search(query))

        return response.map(post => new Post(post))
    }
}

export default new PostsRepository()
